export enum OfferAlertFilterCriteriaFieldEnum {
  WINE_UUID = "wine-uuid",
  COUNTRY_CODE = "country-code",
  REGION_UUID = "region-uuid",
  WINERY_UUID = "winery-uuid",
  WINE_TYPE_UUID = "wine-type-uuid",
  VINTAGE = "vintage",
  MILLILITERS = "milliliters",
  PRICE = "price",
  PRICE_CURRENCY = "price-currency",
  QUANTITY = "quantity",
  VIVINO_AVERAGE = "vivino-average",
  VIVINO_COUNT = "vivino-count",
  B2B_MARKET_PRICE = "b2b-market-price",
  MAPPED_EXTERNAL_WINERY = "mapped-external-winery",
  MAPPED_EXTERNAL_WINE = "mapped-external-wine",
  SUPPLIER_UUID = "supplier-uuid",
  UPLOAD_UUID = "upload-uuid",
  VINTAGE_SCORE = "vintage-score",
}
